import { PathBase } from "@constellation-academy/epic-ui";

export class LevelDefinitionEditPath extends PathBase {
	static readonly pathKey = "edit";
}
